"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var rxjs_1 = require("rxjs");
var TimerService = /** @class */ (function () {
    function TimerService() {
        var _this = this;
        this.intervalSubjects = {};
        this.timerWorker = new Worker('./timer-worker2.js');
        this.timerWorker.onmessage = function (e) {
            var subject = _this.intervalSubjects[e.data.id];
            if (subject) {
                subject.next(e.data.time);
            }
        };
    }
    TimerService.prototype.registerInterval = function (id, interval) {
        if (this.intervalSubjects[id]) {
            throw Error("Interval with id(" + id + ") already exist.");
        }
        else {
            var sub = new rxjs_1.Subject();
            this.intervalSubjects[id] = sub;
            this.timerWorker.postMessage({
                method: 'registerInterval',
                args: [id, interval]
            });
            return sub.asObservable();
        }
    };
    TimerService.prototype.deregisterInterval = function (id) {
        var subject = this.intervalSubjects[id];
        if (subject) {
            this.timerWorker.postMessage({
                method: 'deregisterInterval',
                args: [id]
            });
            subject.complete();
            delete this.intervalSubjects[id];
        }
    };
    return TimerService;
}());
var instance = new TimerService();
exports.default = instance;
//# sourceMappingURL=timerService.js.map


// WEBPACK FOOTER //
// ./src/core/services/data/timerService.js